export default "__VITE_ASSET__DzRCDJHI__"